<div class="additional-admins-page">
    <div class="content">
        <h1>Setting Up Additional Administrators for EZ DOCS</h1>

        <p>
            For security purposes, there should be at least two system administrators for each dealership. Please complete the form below to identify another
            person(s) who will serve in this role for
            <strong>{{ dealerName }} ({{ dealerCode }}).</strong>
        </p>

        <p>
            You can identify up to two additional system administrators here. If you want to add more, you can do so in the User Management section of the
            application. A Welcome Message will be sent to them so they can complete their account set up.
        </p>

        <p class="required-disclaimer">All fields are required.</p>

        <form [formGroup]="admin1Form">
            <mat-form-field>
                <mat-label>Email</mat-label>
                <input class="dealer-code" matInput formControlName="email" (change)="checkIfUserExistsForEmail(true)" />
            </mat-form-field>
            <p *ngIf="admin1ExistingUser" class="user-exists">
                This individual already has a user profile in the system. Please review the information below and update it if necessary.
            </p>
            <div class="form-group-layout-1">
                <mat-form-field>
                    <mat-label>First Name</mat-label>
                    <input class="dealer-code" matInput formControlName="firstName" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Last Name</mat-label>
                    <input class="dealer-code" matInput formControlName="lastName" />
                </mat-form-field>
            </div>
            <div class="form-group-layout-2">
                <mat-form-field>
                    <mat-label>Mobile Phone (required for 2 factor auth)</mat-label>
                    <input class="dealer-code" matInput appPhoneMask placeholder="(XXX) XXX-XXXX" maxlength="14" formControlName="mobilePhone" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Job Title *</mat-label>
                    <mat-select [(value)]="jobTitleAdmin1Control" placeholder="Select users' Job Title">
                        <mat-option [value]="title.jobTitle" *ngFor="let title of jobTitles">{{ title.jobTitle }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </form>

        <mat-expansion-panel [expanded]="expandedAdmin2">
            <mat-expansion-panel-header>
                <mat-panel-title> Add Another Administrator </mat-panel-title>
            </mat-expansion-panel-header>

            <form [formGroup]="admin2Form">
                <mat-form-field>
                    <mat-label>Email</mat-label>
                    <input class="dealer-code" matInput formControlName="email" (change)="checkIfUserExistsForEmail(false)" />
                </mat-form-field>
                <p *ngIf="admin2ExistingUser" class="user-exists">
                    This individual already has a user profile in the system. Please review the information below and update it if necessary.
                </p>
                <div class="form-group-layout-1">
                    <mat-form-field>
                        <mat-label>First Name</mat-label>
                        <input class="dealer-code" matInput formControlName="firstName" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Last Name</mat-label>
                        <input class="dealer-code" matInput formControlName="lastName" />
                    </mat-form-field>
                </div>
                <div class="form-group-layout-2">
                    <mat-form-field>
                        <mat-label>Mobile Phone (required for 2 factor auth)</mat-label>
                        <input class="dealer-code" matInput appPhoneMask placeholder="(XXX) XXX-XXXX" maxlength="14" formControlName="mobilePhone" />
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Job Title *</mat-label>
                        <mat-select [(value)]="jobTitleAdmin2Control" placeholder="Select users' Job Title">
                            <mat-option [value]="title.jobTitle" *ngFor="let title of jobTitles">{{ title.jobTitle }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </form>
        </mat-expansion-panel>

        <hr />

        <div class="divider-container">
            <div class="horizontal-bar"></div>
        </div>

        <hr />
        <div class="faux-footer-container">
            <div class="faux-footer-content">
                <p>If you have any questions, please reach out to us.</p>
                <div class="support-wrap">
                    <p><b>EZ DOCS Support</b></p>

                    <p>Phone: {{ tenantSupportPhone }}</p>
                    <p>Email: {{ tenantSupportEmail }}</p>
                </div>
            </div>
            <div class="faux-footer-content faux-footer-continue-item">
                <form (submit)="submit($event)">
                    <div class="btn-wrap">
                        <button mat-button type="submit" class="primary" [disabled]="!enableContinueButton()">Continue</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<ddj-spinner *ngIf="isLoading"></ddj-spinner>
